// Тестовые данные для локальной проверки таблицы
// Используются когда projectId = "test"

export const getMockData = () => {
  return {
    records: [
      {
        id: "rec_test_1",
        fields: {
          id: "rec_test_1",
          'Subcategory': "01-Basement Base Price",
          'Item Name': "Выбор напольного покрытия",
          'Completed': false,
          'MUST READ': ["https://example.com/flooring-guide"],
          'Due Date': "2024-01-15",
          'Delivered By': "CONTRACTOR",
          'PM Review': "REQUIRED",
          'Important Notes': "Обратите внимание на качество материала",
          'Category': "Self-selection",
          'Project Name Text': "Тестовый проект #12345",
          'projectId': "test"
        }
      },
      {
        id: "rec_test_2",
        fields: {
          id: "rec_test_2",
          'Subcategory': "01-Basement Base Price",
          'Item Name': "Выбор цвета стен",
          'Completed': true,
          'MUST READ': [],
          'Due Date': "2024-01-10",
          'Delivered By': "CUSTOMER",
          'PM Review': "NOT REQUIRED",
          'Important Notes': "",
          'Category': "Self-selection",
          'Project Name Text': "Тестовый проект #12345",
          'projectId': "test"
        }
      },
      {
        id: "rec_test_3",
        fields: {
          id: "rec_test_3",
          'Subcategory': "02-Basement add-ons - General",
          'Item Name': "Установка дополнительных розеток",
          'Completed': false,
          'MUST READ': [],
          'Due Date': "2024-01-20",
          'Delivered By': "CONTRACTOR",
          'PM Review': "REQUIRED",
          'Important Notes': "Согласовать расположение с электриком",
          'Category': "Showroom visit",
          'Project Name Text': "Тестовый проект #12345",
          'projectId': "test"
        }
      },
      {
        id: "rec_test_4",
        fields: {
          id: "rec_test_4",
          'Subcategory': "03-Basement add-ons - HVAC",
          'Item Name': "Выбор системы вентиляции",
          'Completed': false,
          'MUST READ': ["https://example.com/hvac-guide"],
          'Due Date': "2024-01-18",
          'Delivered By': "BY THE VENDOR",
          'PM Review': "REQUIRED",
          'Important Notes': "",
          'Category': "Self-selection",
          'Project Name Text': "Тестовый проект #12345",
          'projectId': "test"
        }
      },
      {
        id: "rec_test_5",
        fields: {
          id: "rec_test_5",
          'Subcategory': "10-Bathroom Items",
          'Item Name': "Выбор сантехники",
          'Completed': false,
          'MUST READ': [],
          'Due Date': "2024-01-25",
          'Delivered By': "CUSTOMER",
          'PM Review': "NOT REQUIRED",
          'Important Notes': "Важно выбрать до начала установки",
          'Category': "Showroom visit",
          'Project Name Text': "Тестовый проект #12345",
          'projectId': "test"
        }
      }
    ]
  };
};

